/**
 * Probe Docker Engine socket availability on mount (Workstream B3). Drives the
 * New Connection dialog button (disabled + tooltip when absent) and the
 * start-page empty-state link (shown only when the socket is present). The
 * probe is a cheap existence check — no container queries, no polling.
 */
import { useEffect, useState } from 'react';
import { checkDockerAvailability } from './dockerDiscoveryService';

interface DockerAvailabilityState {
  available: boolean;
  socketPath: string;
  loading: boolean;
}

export function useDockerAvailability(): DockerAvailabilityState {
  const [state, setState] = useState<DockerAvailabilityState>({
    available: false,
    socketPath: '',
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const result = await checkDockerAvailability();
      if (cancelled) return;
      setState({ available: result.available, socketPath: result.socketPath, loading: false });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
